module.exports = __webpack_public_path__ + "static/img/aboutUS_pysq.ac40aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUS_pysq.png
// module id = hQ+e
// module chunks = 1